export const borderWidths = {
  regular: 2,
}
